export * from "./view-resolver.component";
